document.addEventListener('DOMContentLoaded', function () {
  document.body.addEventListener('submit', function (e) {
    if (e.target.matches('form[action^="/en-au/cart/add"]')) {
      e.preventDefault();

      const form = e.target;
      const formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'application/json',
        },
      })
        .then(response => response.json())
        .then(() => {
          // Re-fetch cart to update drawer
          fetch('/cart')
            .then(res => res.text())
            .then(html => {
              const parser = new DOMParser();
              const doc = parser.parseFromString(html, 'text/html');
              const newCartContent = doc.querySelector('#CartDrawer'); // change selector based on theme
              const currentCartDrawer = document.querySelector('#CartDrawer'); // change selector as needed

              if (newCartContent && currentCartDrawer) {
                currentCartDrawer.innerHTML = newCartContent.innerHTML;
              }

              // Optional: Open the drawer if not already
              document.body.classList.add('cart-drawer-open'); // or trigger your drawer open logic
            });
        })
        .catch(error => console.error('Cart add failed:', error));
    }
  });
});